import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Container,
  Divider,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import brandingConfig from '../../config/brandingConfig';

// Styled components
const ImprintContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: '900px',
  margin: '0 auto',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 2,
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1),
}));

const Imprint = () => {
  // Aktuelles Jahr für Copyright
  const currentYear = new Date().getFullYear();
  // Aktuelles Datum für Stand des Impressums
  const currentDate = new Date().toLocaleDateString('de-DE', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });

  return (
    <Container>
      <ImprintContainer elevation={2}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Impressum
        </Typography>
        <Typography variant="subtitle1" align="center" gutterBottom>
          Stand: {currentDate}
        </Typography>

        <Divider sx={{ my: 3 }} />

        <SectionTitle variant="h5" component="h2">
          Angaben gemäß § 5 Telemediengesetz (TMG)
        </SectionTitle>
        <Typography variant="body1" paragraph>
          <strong>Diensteanbieter / Verantwortlich für den Inhalt</strong><br />
          {brandingConfig.owner && <>{brandingConfig.owner}<br /></>}
          {brandingConfig.companyName}<br />
          {brandingConfig.address}<br />
          Deutschland
        </Typography>

        <SectionTitle variant="h5" component="h2">
          Kontakt
        </SectionTitle>
        <Typography variant="body1" paragraph>
          Telefon: {brandingConfig.phone}<br />
          E-Mail: {brandingConfig.email}<br />
          Internet: {brandingConfig.website || brandingConfig.socialMedia?.website || 'https://nextcab.de'}
        </Typography>

        <SectionTitle variant="h5" component="h2">
          Umsatzsteuer-ID
        </SectionTitle>
        <Typography variant="body1" paragraph>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
          (wird nach Erteilung durch das Finanzamt ergänzt)
        </Typography>

        <SectionTitle variant="h5" component="h2">
          Aufsichtsbehörde
        </SectionTitle>
        <Typography variant="body1" paragraph>
          Zuständige Aufsichtsbehörde für Personenbeförderung (Taxi/Mietwagen):<br />
          {brandingConfig.supervisoryAuthority
            ? `${brandingConfig.supervisoryAuthority.name} – ${brandingConfig.supervisoryAuthority.department}, ${brandingConfig.supervisoryAuthority.address}.`
            : 'Kreis Pinneberg – Fachdienst Straßenverkehr – Personenbeförderung, Kurt-Wagener-Straße 11, 25337 Elmshorn.'}
        </Typography>

        <SectionTitle variant="h5" component="h2">
          Berufsrechtliche Regelungen
        </SectionTitle>
        <Typography variant="body1" paragraph>
          Die Tätigkeit unterliegt den Bestimmungen des Personenbeförderungsgesetzes (PBefG) sowie der Verordnung über den Betrieb von Kraftfahrunternehmen im Personenverkehr (BOKraft). Die einschlägigen Vorschriften sind im Bundesgesetzblatt bzw. auf www.gesetze-im-internet.de abrufbar.
        </Typography>

        <SectionTitle variant="h5" component="h2">
          Verantwortlich für journalistisch-redaktionelle Inhalte
        </SectionTitle>
        <Typography variant="body1" paragraph>
          (sofern im App-Blog/Newsbereich journalistische Inhalte angeboten werden)<br />
          {brandingConfig.owner || brandingConfig.companyName}, Anschrift wie oben.
        </Typography>

        <SectionTitle variant="h5" component="h2">
          EU-Streitschlichtung / Verbraucherstreitbeilegung
        </SectionTitle>
        <Typography variant="body1" paragraph>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr<br />
          Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </Typography>

        <SectionTitle variant="h5" component="h2">
          Haftungsausschluss
        </SectionTitle>
        <Typography variant="body1" paragraph>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt verlinkter Seiten sind ausschließlich deren Betreiber verantwortlich.
        </Typography>

        <SectionTitle variant="h5" component="h2">
          Hinweis zur White-Label-Version
        </SectionTitle>
        <Typography variant="body1" paragraph>
          Bei dieser Anwendung handelt es sich um eine White-Label-Version der NextCab-Plattform, die durch den jeweiligen Lizenznehmer betrieben wird. Für den Inhalt und die rechtlichen Angaben ist ausschließlich der oben genannte Diensteanbieter verantwortlich.
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Bei White-Label-Versionen müssen alle Kontaktinformationen entsprechend angepasst werden. Die technische Plattform wird von NextCab bereitgestellt, der rechtliche Betreiber ist jedoch der Lizenznehmer.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="body2" color="textSecondary">
            © {currentYear} {brandingConfig.companyName}
          </Typography>
        </Box>
      </ImprintContainer>
    </Container>
  );
};

export default Imprint;